import React from "react";
import { Container } from "react-bootstrap";
import AboutBannerImg from "../../assets/images/aboutbanner2.jpg";
import { FaCircleExclamation } from "react-icons/fa6";
const AboutBanner = () => {
  return (
    <section className="aboutbanner">
      <Container>
        <div className="aboutbanner-content">
          <h5>
            <span className="aboutbanner-icon">
              <FaCircleExclamation />
            </span>
            Welcome to Carap
          </h5>
           <h2>
            where quality meets convenience.
          </h2>
          <h6>
            We believe shopping should be simple, enjoyable, and trustworthy.
            That’s why we bring you a curated range of premium products,
            delivered right to your doorstep.
          </h6>
          <img src={AboutBannerImg} alt="banner_img" loading="lazy" className="img-fluid" />
        </div>
      </Container>
    </section>
  );
};
export default AboutBanner;
